import { FC, memo } from 'react';
import { QuestionnaireTemplatesList } from '../../components/Questionnaires/QuestionnaireTemplatesList';

export const QuestionnaireTemplatesScreen: FC = memo(() => {
  return <QuestionnaireTemplatesList />;
});

QuestionnaireTemplatesScreen.displayName = 'QuestionnaireTemplatesScreen';
